var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_149610",
    "data-name": "Group 149610",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.6,
    height: 18.109,
    viewBox: "0 0 16.6 18.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_102376",
    "data-name": "Path 102376",
    d: "M6.6,117.609A3.211,3.211,0,0,1,3.4,114.4v-7.734H2.075A2.077,2.077,0,0,0,0,108.743v10.187A2.077,2.077,0,0,0,2.075,121h9.432a2.077,2.077,0,0,0,2.075-2.075v-1.32Zm0,0",
    transform: "translate(0 -102.895)",
    fill: "#284261"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102377",
    "data-name": "Path 102377",
    d: "M140.073,2.075A2.075,2.075,0,0,0,138,0h-7.923A2.075,2.075,0,0,0,128,2.075v9.432a2.075,2.075,0,0,0,2.075,2.075H138a2.075,2.075,0,0,0,2.075-2.075Zm0,0",
    transform: "translate(-123.473)",
    fill: "#284261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/copyicon.186ab70639052db3bc6ff0f0fe2deb0f.svg";
export { ForwardRef as ReactComponent };